(function () {
  'use strict';

  var LEGACY_HEADER = 'CARD MESSAGE — ';
  var NOTE_SEPARATOR = ' || ';
  var NEW_PREFIX = '[CARD MESSAGE — ';
  var NEW_MIDDLE = '] ';
  var LINE_BREAK_TOKEN = ' ↵ ';

  function jsonRequest(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';

    return window.fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function readCart() {
    return jsonRequest('/cart.js', { method: 'GET' });
  }

  function saveCartNote(note) {
    return jsonRequest('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: note })
    });
  }

  function getProductData() {
    var node = document.querySelector('script[id^="ProductJson-"]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || node.innerText || '{}');
    } catch (error) {
      return null;
    }
  }

  function getItemHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);

    if (item.url) {
      var match = String(item.url).match(/\/products\/([^?/#]+)/);
      if (match && match[1]) return match[1];
    }

    if (item.product_id) return 'product-' + String(item.product_id);
    return '';
  }

  function getItemTitle(item) {
    if (!item) return 'Product';
    return String(item.product_title || item.title || item.handle || 'Product');
  }

  function findItemByTitle(items, title) {
    var cleanTitle = String(title || '').replace(/^\s+|\s+$/g, '');
    var i;

    for (i = 0; i < items.length; i += 1) {
      if (getItemTitle(items[i]) === cleanTitle) return items[i];
    }

    return null;
  }

  function findTitleAtStart(items, text) {
    var candidates = items.slice().sort(function (a, b) {
      return getItemTitle(b).length - getItemTitle(a).length;
    });
    var i;

    for (i = 0; i < candidates.length; i += 1) {
      var title = getItemTitle(candidates[i]);
      if (text.indexOf(title) === 0) {
        return {
          item: candidates[i],
          title: title,
          rest: text.slice(title.length)
        };
      }
    }

    return null;
  }

  function encodeMessage(message) {
    return String(message || '')
      .replace(/\r\n|\r|\n/g, LINE_BREAK_TOKEN)
      .replace(/\|\|/g, '｜｜')
      .replace(/^\s+|\s+$/g, '');
  }

  function decodeMessage(message) {
    return String(message || '')
      .replace(/｜｜/g, '||')
      .split(LINE_BREAK_TOKEN).join('\n')
      .replace(/^\s+|\s+$/g, '');
  }

  function isInternalMessage(value) {
    var text = String(value || '');
    return text.indexOf(NEW_PREFIX) !== -1 ||
      text.indexOf(LEGACY_HEADER) !== -1 ||
      /\[CARD MESSAGE\s*[—-]/i.test(text);
  }

  function sanitizeCustomerMessage(value) {
    var text = String(value || '').replace(/^\s+|\s+$/g, '');
    if (!text || isInternalMessage(text)) return '';
    return text;
  }

  function parseNewFormat(text, items, messages) {
    text.split(NOTE_SEPARATOR).forEach(function (segment) {
      var match = segment.match(/^\[CARD MESSAGE — (.+?)\]\s*(.*)$/);
      if (!match) return;

      var item = findItemByTitle(items, match[1]);
      if (!item) return;

      var decoded = sanitizeCustomerMessage(decodeMessage(match[2]));
      if (!decoded) return;

      messages[getItemHandle(item)] = decoded;
    });
  }

  function parseLegacyMultiline(text, items, messages) {
    var lines = text.replace(/\r\n/g, '\n').split('\n');
    var currentItem = null;
    var buffer = [];

    function commit() {
      if (!currentItem) return;
      var decoded = sanitizeCustomerMessage(buffer.join('\n'));
      if (decoded) messages[getItemHandle(currentItem)] = decoded;
      currentItem = null;
      buffer = [];
    }

    lines.forEach(function (line) {
      if (line.indexOf(LEGACY_HEADER) === 0) {
        commit();
        currentItem = findItemByTitle(items, line.slice(LEGACY_HEADER.length));
      } else if (currentItem) {
        buffer.push(line);
      }
    });

    commit();
  }

  function parseLegacyWithHeaders(text, items, messages) {
    var parts = text.split(LEGACY_HEADER);

    parts.forEach(function (part, index) {
      if (index === 0 || !part) return;

      var clean = part.replace(/^\s+/, '');
      var titleMatch = findTitleAtStart(items, clean);
      if (!titleMatch) return;

      var remainder = titleMatch.rest
        .replace(/^\s*[:\-–—]?\s*/, '')
        .replace(/^\s+|\s+$/g, '');

      var decoded = sanitizeCustomerMessage(decodeMessage(remainder));
      if (decoded) messages[getItemHandle(titleMatch.item)] = decoded;
    });
  }

  function parseCardMessages(note, items) {
    var messages = {};
    var text = typeof note === 'string' ? note : '';
    var trimmed = text.replace(/^\s+|\s+$/g, '');

    if (!trimmed) return messages;

    if (text.indexOf(NEW_PREFIX) !== -1) {
      parseNewFormat(text, items, messages);
      return messages;
    }

    if (text.indexOf(LEGACY_HEADER) !== -1) {
      if (text.indexOf('\n') !== -1) {
        parseLegacyMultiline(text, items, messages);
      } else {
        parseLegacyWithHeaders(text, items, messages);
      }
      return messages;
    }

    if (items.length === 1) {
      var legacyMessage = sanitizeCustomerMessage(trimmed);
      if (legacyMessage) messages[getItemHandle(items[0])] = legacyMessage;
    }

    return messages;
  }

  function serializeCardMessages(items, messages) {
    var sections = [];
    var seen = {};

    items.forEach(function (item) {
      var handle = getItemHandle(item);
      if (!handle || seen[handle]) return;
      seen[handle] = true;

      var message = messages[handle];
      if (typeof message !== 'string') return;

      message = sanitizeCustomerMessage(message);
      if (!message) return;

      sections.push(
        NEW_PREFIX + getItemTitle(item) + NEW_MIDDLE + encodeMessage(message)
      );
    });

    return sections.join(NOTE_SEPARATOR);
  }

  function createAySlot() {
    return 'ay-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function buildProductMessageBlock() {
    var details = document.createElement('details');
    details.className = 'ay-product-card-message';
    details.setAttribute('data-ay-product-card-message', '');

    var summary = document.createElement('summary');
    summary.className = 'ay-product-card-message__summary';
    summary.innerHTML =
      '<span class="ay-product-card-message__label">Card Message</span>' +
      '<span class="ay-product-card-message__free">Complimentary</span>' +
      '<span class="ay-product-card-message__icon" aria-hidden="true"></span>';

    var body = document.createElement('div');
    body.className = 'ay-product-card-message__body';

    var units = document.createElement('div');
    units.setAttribute('data-ay-card-message-units', '');

    var helper = document.createElement('p');
    helper.className = 'ay-product-card-message__helper';
    helper.textContent = 'We’ll print your message on a premium card and include it with your flowers at no extra charge.';

    var error = document.createElement('p');
    error.className = 'ay-product-card-message__error';
    error.setAttribute('data-ay-card-message-error', '');
    error.setAttribute('role', 'alert');
    error.hidden = true;

    body.appendChild(units);
    body.appendChild(helper);
    body.appendChild(error);
    details.appendChild(summary);
    details.appendChild(body);

    return details;
  }

  function initProductCardMessage() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (!window.fetch) return;

    var form = document.querySelector('.product-section[data-section-type="product-template"] form.variations_form.cart');
    if (!form || form.querySelector('[data-ay-product-card-message]')) return;

    var buttonArea = form.querySelector('.variations_button');
    var addButton = form.querySelector('.add_to_cart_button');
    var quantityInput = form.querySelector('input[name="quantity"]');
    var variantInput = form.querySelector('[name="id"]');
    if (!buttonArea || !addButton || !quantityInput || !variantInput) return;

    var block = buildProductMessageBlock();
    form.insertBefore(block, buttonArea);

    var unitsWrap = block.querySelector('[data-ay-card-message-units]');
    var error = block.querySelector('[data-ay-card-message-error]');

    var hiddenMessage = document.createElement('input');
    hiddenMessage.type = 'hidden';
    hiddenMessage.name = 'properties[Card Message]';

    var hiddenSlot = document.createElement('input');
    hiddenSlot.type = 'hidden';
    hiddenSlot.name = 'properties[_AY Card Slot]';

    form.appendChild(hiddenMessage);
    form.appendChild(hiddenSlot);

    function readQuantity() {
      var quantity = parseInt(quantityInput.value, 10);
      if (isNaN(quantity) || quantity < 1) quantity = 1;
      if (quantity > 20) quantity = 20;
      return quantity;
    }

    function renderUnits() {
      var quantity = readQuantity();
      var existing = Array.prototype.map.call(
        unitsWrap.querySelectorAll('.ay-product-card-message__input'),
        function (input) { return input.value || ''; }
      );

      unitsWrap.innerHTML = '';

      for (var i = 0; i < quantity; i += 1) {
        var unit = document.createElement('div');
        unit.className = 'ay-product-card-message__unit';

        if (quantity > 1) {
          var label = document.createElement('label');
          label.className = 'ay-product-card-message__unit-label';
          label.textContent = 'Card Message for item ' + (i + 1);
          unit.appendChild(label);
        }

        var textarea = document.createElement('textarea');
        textarea.className = 'ay-product-card-message__input';
        textarea.setAttribute('data-ay-card-message-input', '');
        textarea.setAttribute('rows', '3');
        textarea.setAttribute('maxlength', '500');
        textarea.setAttribute('placeholder', 'Write your personal message…');
        textarea.setAttribute('aria-label', quantity > 1 ? 'Card Message for item ' + (i + 1) : 'Card Message');
        textarea.value = existing[i] || '';

        unit.appendChild(textarea);
        unitsWrap.appendChild(unit);
      }
    }

    function collectBaseProperties() {
      var result = {};
      var fields = form.querySelectorAll('[name^="properties["]');

      Array.prototype.forEach.call(fields, function (field) {
        if (!field.name || field === hiddenMessage || field === hiddenSlot) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;

        var match = field.name.match(/^properties\[(.*)\]$/);
        if (!match || !match[1]) return;

        result[match[1]] = field.value || '';
      });

      return result;
    }

    function getMessages() {
      return Array.prototype.map.call(
        unitsWrap.querySelectorAll('.ay-product-card-message__input'),
        function (input) { return sanitizeCustomerMessage(input.value || ''); }
      );
    }

    quantityInput.addEventListener('input', renderUnits);
    quantityInput.addEventListener('change', renderUnits);
    renderUnits();

    addButton.addEventListener('click', function (event) {
      var quantity = readQuantity();
      var messages = getMessages();

      error.hidden = true;
      error.textContent = '';

      if (quantity === 1) {
        hiddenMessage.value = messages[0] || '';
        hiddenSlot.value = createAySlot();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      var variantId = variantInput.value;
      if (!variantId) {
        error.textContent = 'Please select a product option.';
        error.hidden = false;
        return;
      }

      var baseProperties = collectBaseProperties();
      var items = [];

      for (var i = 0; i < quantity; i += 1) {
        var properties = {};
        Object.keys(baseProperties).forEach(function (key) {
          properties[key] = baseProperties[key];
        });

        if (messages[i]) properties['Card Message'] = messages[i];
        properties['_AY Card Slot'] = createAySlot();

        items.push({
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: properties
        });
      }

      addButton.classList.add('ay-card-note-saving');

      jsonRequest('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {
        addButton.classList.remove('ay-card-note-saving');
        error.textContent = 'We could not add these items to your cart. Please try again.';
        error.hidden = false;
      });
    }, true);
  }

  function initCollectionLineSlots() {
    document.addEventListener('click', function (event) {
      var button = event.target && event.target.closest
        ? event.target.closest('.ajax_add_to_cart')
        : null;
      if (!button) return;

      var form = button.closest('form');
      if (!form) return;

      var slot = form.querySelector('input[name="properties[_AY Card Slot]"]');
      if (!slot) {
        slot = document.createElement('input');
        slot.type = 'hidden';
        slot.name = 'properties[_AY Card Slot]';
        form.appendChild(slot);
      }

      slot.value = createAySlot();
    }, true);
  }

  function normalizePropertyKey(key, value) {
    var rawKey = String(key || '').replace(/^\s+|\s+$/g, '');
    var rawValue = String(value || '');
    var combined = (rawKey + ' ' + rawValue).toLowerCase();

    if (combined.indexOf('delivery / pickup date') !== -1 ||
        combined.indexOf('delivery pickup date') !== -1 ||
        combined.indexOf('delivery date') !== -1) {
      return 'Delivery / Pickup Date';
    }

    return rawKey;
  }

  function normalizePropertyValue(key, value) {
    var raw = String(value || '');
    var combined = (String(key || '') + ' ' + raw).toLowerCase();

    if (combined.indexOf('delivery') !== -1 && combined.indexOf('date') !== -1) {
      var dates = (String(key || '') + ' ' + raw).match(/\d{1,2}\/\d{1,2}\/\d{4}/g);
      if (dates && dates.length) return dates[0];
    }

    return raw.replace(/^\s+|\s+$/g, '');
  }

  function getCleanProperties(item) {
    var properties = item && item.properties ? item.properties : {};
    var rows = [];
    var seen = {};

    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (!key || key.charAt(0) === '_') return;
      if (String(key).toLowerCase() === 'card message') return;
      if (value === null || value === undefined || String(value).replace(/^\s+|\s+$/g, '') === '') return;

      var cleanKey = normalizePropertyKey(key, value);
      var cleanValue = normalizePropertyValue(key, value);
      if (!cleanKey || !cleanValue) return;
      if (/^\d+$/.test(cleanKey) && cleanValue.indexOf('/') === -1) return;

      var dedupeKey = cleanKey.toLowerCase() + '|' + cleanValue.toLowerCase();
      if (seen[dedupeKey]) return;
      seen[dedupeKey] = true;
      rows.push({ key: cleanKey, value: cleanValue });
    });

    return rows;
  }

  function cleanCartItemMeta(row, item, index) {
    var cell = row.querySelector('.product-name');
    if (!cell) return;

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var variantMeta = cell.querySelector('.cart_meta .variation');
    var variantWrap = variantMeta ? variantMeta.parentNode : null;
    var properties = getCleanProperties(item);

    Array.prototype.forEach.call(cell.querySelectorAll('.cart_meta'), function (meta) {
      if (!meta.querySelector('.variation')) meta.style.display = 'none';
    });

    var oldClean = cell.querySelector('.ay-cart-clean-properties');
    if (oldClean) oldClean.parentNode.removeChild(oldClean);

    if (isMobile) {
      var details = [];
      var seen = {};

      function addDetail(key, value) {
        var cleanKey = String(key || '').replace(/:\s*$/, '').replace(/^\s+|\s+$/g, '');
        var cleanValue = String(value || '').replace(/^\s+|\s+$/g, '');
        if (!cleanKey || !cleanValue) return;

        var dedupeKey = cleanKey.toLowerCase() + '|' + cleanValue.toLowerCase();
        if (seen[dedupeKey]) return;
        seen[dedupeKey] = true;
        details.push({ key: cleanKey, value: cleanValue });
      }

      if (variantMeta) {
        var labels = variantMeta.querySelectorAll('dt');
        var values = variantMeta.querySelectorAll('dd');

        Array.prototype.forEach.call(labels, function (label, i) {
          addDetail(label.textContent, values[i] ? values[i].textContent : '');
        });
      }

      properties.forEach(function (property) {
        addDetail(property.key, property.value);
      });

      if (variantWrap) variantWrap.style.display = 'none';

      var existingDetailsRow = document.querySelector('.ay-cart-item-details-row[data-ay-details-index="' + index + '"]');
      if (existingDetailsRow && existingDetailsRow.parentNode) {
        existingDetailsRow.parentNode.removeChild(existingDetailsRow);
      }

      if (details.length && row.parentNode) {
        var detailsRow = document.createElement('tr');
        detailsRow.className = 'ay-cart-item-details-row';
        detailsRow.setAttribute('data-ay-details-index', String(index));

        var detailsCell = document.createElement('td');
        detailsCell.colSpan = Math.max(row.children ? row.children.length : 1, 1);
        detailsCell.className = 'ay-cart-item-details-cell';

        var detailsWrap = document.createElement('div');
        detailsWrap.className = 'ay-cart-item-details';

        details.forEach(function (detail) {
          var line = document.createElement('div');
          line.className = 'ay-cart-item-detail';

          var label = document.createElement('span');
          label.className = 'ay-cart-item-detail__label';
          label.textContent = detail.key + ':';

          var value = document.createElement('span');
          value.className = 'ay-cart-item-detail__value';
          value.textContent = detail.value;

          line.appendChild(label);
          line.appendChild(value);
          detailsWrap.appendChild(line);
        });

        detailsCell.appendChild(detailsWrap);
        detailsRow.appendChild(detailsCell);
        row.parentNode.insertBefore(detailsRow, row.nextSibling);
      }

      return;
    }

    if (!properties.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'ay-cart-clean-properties';

    properties.forEach(function (property) {
      var line = document.createElement('div');
      line.className = 'ay-cart-clean-property';

      var label = document.createElement('span');
      label.className = 'ay-cart-clean-property__label';
      label.textContent = property.key + ':';

      var value = document.createElement('span');
      value.className = 'ay-cart-clean-property__value';
      value.textContent = property.value;

      line.appendChild(label);
      line.appendChild(value);
      wrap.appendChild(line);
    });

    if (variantWrap && variantWrap.parentNode === cell) {
      variantWrap.insertAdjacentElement('afterend', wrap);
    } else {
      var title = cell.querySelector('.item_title');
      if (title) title.insertAdjacentElement('afterend', wrap);
      else cell.insertBefore(wrap, cell.firstChild);
    }
  }

  function buildCartItemMessageEditor(item, message, index) {
    var root = document.createElement('div');
    var textareaId = 'ay-cart-card-message-' + index;
    var hasMessage = !!sanitizeCustomerMessage(message);

    root.className = 'ay-cart-item-card-message';
    root.setAttribute('data-ay-cart-item-card-message', '');
    root.setAttribute('data-ay-card-index', String(index));

    root.innerHTML =
      '<div class="ay-cart-item-card-message__view" data-ay-card-view>' +
        '<div class="ay-cart-item-card-message__topline">' +
          '<span class="ay-cart-item-card-message__title" data-ay-card-title></span>' +
          '<button type="button" class="ay-cart-item-card-message__edit" data-ay-card-edit>' + (hasMessage ? 'EDIT MESSAGE' : 'ADD MESSAGE') + '</button>' +
        '</div>' +
        '<div class="ay-cart-item-card-message__text' + (hasMessage ? '' : ' is-empty') + '" data-ay-card-text></div>' +
      '</div>' +
      '<div class="ay-cart-item-card-message__editor" data-ay-card-editor hidden>' +
        '<label class="ay-cart-item-card-message__editor-label" data-ay-card-editor-label for="' + textareaId + '"></label>' +
        '<textarea id="' + textareaId + '" class="ay-cart-item-card-message__textarea" rows="3" maxlength="500" placeholder="Write your personal message…"></textarea>' +
        '<p class="ay-cart-item-card-message__status" data-ay-card-status role="status" aria-live="polite"></p>' +
      '</div>';

    var cartTitle = 'Card Message for: ' + getItemTitle(item);
    root.querySelector('[data-ay-card-title]').textContent = cartTitle;
    root.querySelector('[data-ay-card-editor-label]').textContent = cartTitle;
    root.querySelector('[data-ay-card-text]').textContent = hasMessage ? sanitizeCustomerMessage(message) : 'No message added';
    root.querySelector('.ay-cart-item-card-message__textarea').value = sanitizeCustomerMessage(message);

    return root;
  }

  function clearDynamicCartUi() {
    Array.prototype.forEach.call(document.querySelectorAll('.ay-cart-card-message-row, .ay-cart-item-details-row'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-ay-cart-item-card-message]'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    Array.prototype.forEach.call(document.querySelectorAll('.ay-cart-clean-properties'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function placeCartEditor(row, cell, editor, index) {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    if (!isMobile) {
      cell.appendChild(editor);
      return;
    }

    var messageRow = document.createElement('tr');
    messageRow.className = 'ay-cart-card-message-row';
    messageRow.setAttribute('data-ay-card-index', String(index));

    var messageCell = document.createElement('td');
    messageCell.colSpan = Math.max(row.children ? row.children.length : 1, 1);
    messageCell.className = 'ay-cart-card-message-cell';
    messageCell.appendChild(editor);

    messageRow.appendChild(messageCell);

    if (row.parentNode) {
      var detailsRow = document.querySelector('.ay-cart-item-details-row[data-ay-details-index="' + index + '"]');
      if (detailsRow && detailsRow.parentNode === row.parentNode) {
        row.parentNode.insertBefore(messageRow, detailsRow.nextSibling);
      } else {
        row.parentNode.insertBefore(messageRow, row.nextSibling);
      }
    } else {
      cell.appendChild(editor);
    }
  }


  function copyProperties(sourceProperties) {
    var result = {};
    Object.keys(sourceProperties || {}).forEach(function (key) {
      result[key] = sourceProperties[key];
    });
    return result;
  }

  function buildAdditionalUnitProperties(sourceProperties) {
    var result = copyProperties(sourceProperties);

    delete result['Card Message'];
    delete result['Delivery / Pickup Date'];
    delete result['Delivery Date'];
    delete result['_AY Delivery Date'];
    delete result['_AY Card Slot'];

    result['_AY Card Slot'] = createAySlot();
    return result;
  }

  function ensureFirstUnitProperties(sourceProperties) {
    var result = copyProperties(sourceProperties);
    if (!result['_AY Card Slot']) result['_AY Card Slot'] = createAySlot();
    return result;
  }

  function initCartQuantitySplitter() {
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    if (!window.fetch) return;

    var cartForm = document.querySelector('form.shopping-cart');
    if (!cartForm || cartForm.getAttribute('data-ay-quantity-splitter') === '1') return;

    cartForm.setAttribute('data-ay-quantity-splitter', '1');

    cartForm.addEventListener('submit', function (event) {
      if (event.defaultPrevented) return;

      var submitter = event.submitter || document.activeElement;
      if (!submitter || submitter.name !== 'update') return;

      var quantityInputs = Array.prototype.slice.call(
        cartForm.querySelectorAll('input[name="updates[]"]')
      );

      if (!quantityInputs.length) return;

      var requestedQuantities = quantityInputs.map(function (input) {
        var quantity = parseInt(input.value, 10);
        if (isNaN(quantity) || quantity < 0) quantity = 0;
        if (quantity > 20) quantity = 20;
        return quantity;
      });

      var needsPhysicalSplit = requestedQuantities.some(function (quantity) {
        return quantity > 1;
      });

      if (!needsPhysicalSplit) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      submitter.disabled = true;
      submitter.classList.add('ay-card-note-saving');

      var cardMessageFlush = typeof window.AYFlushCardMessages === 'function'
        ? window.AYFlushCardMessages()
        : Promise.resolve();

      cardMessageFlush.then(function () {
        return readCart();
      }).then(function (cart) {
        var items = cart.items || [];
        if (items.length !== requestedQuantities.length) {
          throw new Error('Cart changed before quantity update.');
        }

        var chain = Promise.resolve();

        items.forEach(function (item, index) {
          var requestedQuantity = requestedQuantities[index];

          chain = chain.then(function () {
            if (requestedQuantity <= 1) {
              if (requestedQuantity === item.quantity) return;

              return jsonRequest('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: requestedQuantity
                })
              });
            }

            var firstProperties = ensureFirstUnitProperties(item.properties || {});

            return jsonRequest('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 1,
                properties: firstProperties
              })
            }).then(function () {
              var extraItems = [];

              for (var unitIndex = 1; unitIndex < requestedQuantity; unitIndex += 1) {
                extraItems.push({
                  id: item.variant_id || item.id,
                  quantity: 1,
                  properties: buildAdditionalUnitProperties(firstProperties)
                });
              }

              if (!extraItems.length) return;

              return jsonRequest('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ items: extraItems })
              });
            });
          });
        });

        return chain;
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {
        submitter.disabled = false;
        submitter.classList.remove('ay-card-note-saving');
        window.alert('We could not update the cart quantity. Please try again.');
      });
    });
  }

  function scheduleCartQuantitySplitter() {
    if (document.readyState === 'complete') {
      window.setTimeout(initCartQuantitySplitter, 0);
      return;
    }

    window.addEventListener('load', function () {
      window.setTimeout(initCartQuantitySplitter, 0);
    });
  }

  function initCartMessageEditors(forceRebuild) {
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    if (!window.fetch) return;

    if (forceRebuild) clearDynamicCartUi();

    readCart().then(function (cart) {
      var items = cart.items || [];
      if (!items.length) return;

      var rows = document.querySelectorAll('tr.cart_item');
      var timers = {};
      var dirty = {};
      var savingPromises = {};

      function syncDeliveryLine(index, cartAfter) {
        if (!window.AYDeliveryLineItems || !window.AYDeliveryLineItems[index]) return;
        if (!cartAfter || !cartAfter.items || !cartAfter.items[index]) return;

        window.AYDeliveryLineItems[index].key = cartAfter.items[index].key;
        window.AYDeliveryLineItems[index].properties = cartAfter.items[index].properties || {};
      }

      function saveLine(index, value) {
        var item = items[index];
        if (!item) return Promise.resolve();

        if (timers[index]) {
          window.clearTimeout(timers[index]);
          timers[index] = null;
        }

        var properties = {};
        Object.keys(item.properties || {}).forEach(function (key) {
          properties[key] = item.properties[key];
        });

        var clean = sanitizeCustomerMessage(value);
        if (clean) properties['Card Message'] = clean;
        else delete properties['Card Message'];

        if (!properties['_AY Card Slot']) {
          properties['_AY Card Slot'] = createAySlot();
        }

        var current = sanitizeCustomerMessage((item.properties || {})['Card Message'] || '');
        if (current === clean && item.properties && item.properties['_AY Card Slot']) {
          dirty[index] = false;
          return Promise.resolve();
        }

        dirty[index] = true;

        var request = jsonRequest('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: item.key,
            properties: properties
          })
        }).then(function (updatedCart) {
          if (updatedCart && updatedCart.items && updatedCart.items[index]) {
            items[index] = updatedCart.items[index];
          } else {
            item.properties = properties;
          }

          syncDeliveryLine(index, updatedCart);
          dirty[index] = false;
          return updatedCart;
        });

        savingPromises[index] = request;
        return request.finally(function () {
          if (savingPromises[index] === request) delete savingPromises[index];
        });
      }

      window.AYFlushCardMessages = function () {
        var chain = Promise.resolve();

        Array.prototype.forEach.call(document.querySelectorAll('[data-ay-cart-item-card-message]'), function (editor) {
          var index = parseInt(editor.getAttribute('data-ay-card-index'), 10);
          var input = editor.querySelector('.ay-cart-item-card-message__textarea');
          if (isNaN(index) || !input) return;

          if (timers[index]) {
            window.clearTimeout(timers[index]);
            timers[index] = null;
            dirty[index] = true;
          }

          if (dirty[index]) {
            chain = chain.then(function () {
              return saveLine(index, input.value || '');
            });
          } else if (savingPromises[index]) {
            chain = chain.then(function () {
              return savingPromises[index];
            });
          }
        });

        return chain;
      };

      Array.prototype.forEach.call(rows, function (row, index) {
        var item = items[index];
        if (!item) return;

        cleanCartItemMeta(row, item, index);

        var cell = row.querySelector('.product-name');
        if (!cell || row.querySelector('[data-ay-cart-item-card-message]')) return;
        if (document.querySelector('.ay-cart-card-message-row[data-ay-card-index="' + index + '"]')) return;

        var message = sanitizeCustomerMessage((item.properties || {})['Card Message'] || '');
        var editor = buildCartItemMessageEditor(item, message, index);
        placeCartEditor(row, cell, editor, index);

        var view = editor.querySelector('[data-ay-card-view]');
        var editPanel = editor.querySelector('[data-ay-card-editor]');
        var text = editor.querySelector('[data-ay-card-text]');
        var textarea = editor.querySelector('.ay-cart-item-card-message__textarea');
        var status = editor.querySelector('[data-ay-card-status]');
        var editButton = editor.querySelector('[data-ay-card-edit]');

        function renderValue(value) {
          var clean = sanitizeCustomerMessage(value);
          text.textContent = clean || 'No message added';
          text.classList.toggle('is-empty', !clean);
          editButton.textContent = clean ? 'EDIT MESSAGE' : 'ADD MESSAGE';
        }

        function showEditor() {
          view.hidden = true;
          editPanel.hidden = false;
          status.textContent = '';
          textarea.focus();
        }

        editButton.addEventListener('click', showEditor);

        textarea.addEventListener('input', function () {
          dirty[index] = true;
          renderValue(textarea.value || '');
          status.textContent = 'Saving automatically…';

          if (timers[index]) window.clearTimeout(timers[index]);
          timers[index] = window.setTimeout(function () {
            timers[index] = null;

            saveLine(index, textarea.value || '').then(function () {
              status.textContent = 'Saved automatically.';
            }).catch(function () {
              status.textContent = 'Could not save automatically. Please try again.';
            });
          }, 450);
        });

        textarea.addEventListener('blur', function () {
          if (!dirty[index] && !timers[index]) return;

          saveLine(index, textarea.value || '').then(function () {
            status.textContent = 'Saved automatically.';
          }).catch(function () {
            status.textContent = 'Could not save automatically. Please try again.';
          });
        });
      });
    }).catch(function () {});
  }

  function init() {
    initProductCardMessage();
    initCollectionLineSlots();
    initCartMessageEditors(false);
    scheduleCartQuantitySplitter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted && document.body && document.body.classList.contains('template-cart')) {
      initCartMessageEditors(true);
    }
  });
})();